var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "oaFromBox",
        {
          attrs: {
            isAddBtn: false,
            title: "我的申请",
            search: _vm.search,
            total: _vm.total,
            isViewSearch: false,
          },
          on: { confirmData: _vm.confirmData },
        },
        [
          _c(
            "template",
            { slot: "rightBtn" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: {
                    trigger: "click",
                    size: "small",
                    placement: "bottom-start",
                  },
                  on: { command: _vm.handleBuild },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["user:examine:add"],
                          expression: "['user:examine:add']",
                        },
                      ],
                      attrs: { type: "primary", size: "small" },
                    },
                    [_vm._v("发起申请")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "build-dropdown",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    _vm._l(_vm.dropdownList, function (item, index) {
                      return _c(
                        "el-dropdown-item",
                        {
                          key: item.id,
                          staticClass: "over-text",
                          attrs: { placement: "top-end", command: item.id },
                        },
                        [
                          _c("i", {
                            staticClass: "iconfont",
                            class: item.icon,
                            style: { color: item.color },
                          }),
                          _vm._v(
                            "\n            " +
                              _vm._s(item.name) +
                              "\n          "
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _vm.tableData.length > 0
        ? _c(
            "div",
            { staticClass: "table-box mt10" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    height: _vm.tableHeight,
                    "row-key": "id",
                    "default-expand-all": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "审批类型",
                      "min-width": "250",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-row",
                                { staticClass: "table-title" },
                                [
                                  _c(
                                    "el-col",
                                    { staticClass: "table-title-left" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "selIcon",
                                          style: {
                                            backgroundColor:
                                              scope.row.approve.color,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon iconfont",
                                            class: scope.row.approve.icon,
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-col",
                                    { staticClass: "table-title-right" },
                                    [
                                      _c("p", { staticClass: "title" }, [
                                        _vm._v(_vm._s(scope.row.approve.name)),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "over-text" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getValue(scope.row.content)
                                          )
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3327609316
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: "审批状态",
                      "min-width": "80",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                { staticClass: "status" },
                                [
                                  scope.row.status === -1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "info",
                                            effect: "plain",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v(" 已撤销 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "warning",
                                            effect: "plain",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v(" 审核中 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "info",
                                            effect: "plain",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v(" 已通过 ")]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  scope.row.status === 2
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: "danger",
                                            effect: "plain",
                                            size: "mini",
                                          },
                                        },
                                        [_vm._v(" 已拒绝 ")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2905802826
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "created_at",
                      label: "提交时间",
                      "min-width": "150",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "name",
                      label: _vm.$t("public.operation"),
                      width: "200",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["user:examine:mine:details"],
                                      expression:
                                        "['user:examine:mine:details']",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleDetail(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("详情\n          ")]
                              ),
                              _vm._v(" "),
                              scope.row.status === 1 && scope.row.type < 6
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("再次提交")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              (scope.row.status === 1 &&
                                scope.row.rules.recall == 1) ||
                              scope.row.status === 0
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRefuse(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("\n            撤销\n          ")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              ([2, -1].includes(scope.row.status) &&
                                scope.row.approve.types < 6) ||
                              scope.row.approve.types > 10
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            重新提交\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2507682888
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "page-fixed" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "page-size": _vm.where.limit,
                      "current-page": _vm.where.page,
                      "page-sizes": [15, 20, 30],
                      layout: "total,sizes, prev, pager, next, jumper",
                      total: _vm.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.pageChange,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c("default-page", {
                directives: [{ name: "height", rawName: "v-height" }],
                attrs: { index: 14, "min-height": 420 },
              }),
            ],
            1
          ),
      _vm._v(" "),
      _c("edit-examine", {
        ref: "editExamine",
        attrs: { type: _vm.type },
        on: {
          isOk: function ($event) {
            return _vm.getTableData()
          },
        },
      }),
      _vm._v(" "),
      _c("detail-examine", {
        ref: "detailExamine",
        on: { getList: _vm.getTableData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }